import $ from "jquery";
import "waypoints/lib/jquery.waypoints";
import "waypoints/lib/shortcuts/sticky";

let $body;

let $document;
let Handbook;

$document = require("../helpers/helpers").default.document;

$body = require("../helpers/helpers").default.body;

Handbook = (() => {
    class Handbook {
        constructor() {
            let me;
            me = this;
            this.$handbook_nav = $(".handbook-footer-navigation");
            this.$nav = $(".handbook-inpage-navigation ul");
            this.$nav_links = $(".handbook-inpage-navigation li");
            this.$section_block = $(".section-block");
            this.onLoad();
            this.changeNav();
        }

        onLoad() {
            return $document.ready(
                (_this => () => {
                    let transitionTime;
                    transitionTime = 500;
                    _this.navigationWaypoints();
                    _this.attachScrollWaypoint();
                    return $document.on(
                        "click",
                        ".handbook-inpage-navigation",
                        ({ target }) => {
                            let $this;
                            $this = $(target);
                            _this.$nav_links.removeClass("active");
                            $this.parent().addClass("active");
                            _this.animateTo(
                                $($this.attr("href")),
                                transitionTime
                            );
                            Waypoint.destroyAll();
                            _this.navigationWaypoints();
                            return setTimeout(
                                () => _this.attachScrollWaypoint(),
                                transitionTime * 2
                            );
                        }
                    );
                })(this)
            );
        }

        animateTo($this, animation_time) {
            if ($this.offset()) {
                return $body.animate(
                    {
                        scrollTop: $this.offset().top
                    },
                    animation_time
                );
            }
        }

        changeNav() {
            switch (window.location.hash) {
                case "#technical_guidelines":
                    this.$nav_links.removeClass("active");
                    return $("[href='#technical_guidelines']")
                        .parent()
                        .addClass("active");
                case "#principles_of_design":
                    this.$nav_links.removeClass("active");
                    return $("[href='#principles_of_design']")
                        .parent()
                        .addClass("active");
                case "#collections":
                    this.$nav_links.removeClass("active");
                    return $("[href='#collections']")
                        .parent()
                        .addClass("active");
                case "#resources":
                    this.$nav_links.removeClass("active");
                    return $("[href='#resources']")
                        .parent()
                        .addClass("active");
                case "#how_to_name":
                    this.$nav_links.removeClass("active");
                    return $("[href='#how_to_name']")
                        .parent()
                        .addClass("active");
                case "#search_words":
                    this.$nav_links.removeClass("active");
                    return $("[href='#search_words']")
                        .parent()
                        .addClass("active");
                case "#licenses":
                    this.$nav_links.removeClass("active");
                    return $("[href='#licenses']")
                        .parent()
                        .addClass("active");
                case "#curation":
                    this.$nav_links.removeClass("active");
                    return $("[href='#curation']")
                        .parent()
                        .addClass("active");
                case "#getting_paid":
                    this.$nav_links.removeClass("active");
                    return $("[href='#getting_paid']")
                        .parent()
                        .addClass("active");
                case "#metrics":
                    this.$nav_links.removeClass("active");
                    return $("[href='#metrics']")
                        .parent()
                        .addClass("active");
            }
        }

        attachScrollWaypoint() {
            let me;
            me = this;
            return this.$section_block.waypoint({
                handler: function() {
                    let hash;
                    hash = $(this.element).data("hash");
                    // Prevent scroll hiccups in FF
                    if (window.location.hash != hash) {
                        window.location.hash = hash;
                    }
                    return me.changeNav();
                },
                offset: "30%"
            });
        }

        navigationWaypoints() {
            return new Waypoint.Sticky({
                element: this.$nav,
                offset: -24
            });
        }
    }

    return Handbook;
})();

export default Handbook;
